import axios from 'axios';
import { getApiBaseUrl } from '../apiBase';

function api() {
    const token = localStorage.getItem('token');
    return axios.create({
        baseURL: getApiBaseUrl(),
        headers: token ? { Authorization: `Bearer ${token}` } : {}
    });
}

export function openPosReceipt(body) {
    return api().post('/pos-receipts', body);
}

export function updatePosReceiptItems(id, schoolId, body) {
    return api().put(`/pos-receipts/${id}/items`, body, { params: { schoolId } });
}

export function payPosReceipt(id, schoolId, body) {
    return api().post(`/pos-receipts/${id}/pay`, body, { params: { schoolId } });
}

export function cancelPosReceipt(id, schoolId) {
    return api().post(`/pos-receipts/${id}/cancel`, null, { params: { schoolId } });
}
